import { useEffect, useState } from 'react';
import { httpInstance } from '@/services/httpInstance';

const useGetProviderById = (id, type) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id || !type) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await httpInstance.get(`/service-payment/v1/beneficiaries/${id}/${type}`);
        setData(response.data);
      } catch (err) {
        setError(err.response);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, type]);

  return { data, error, loading };
};

export default useGetProviderById;
